import BaseEntity from '../BaseEntity.model';

import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';

export default interface IEatingDisorderModel extends BaseEntity {
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    DiagnosedWithEatingDisorder: string;
    AnorexiaNervoxa: boolean;
    BulimiaNervosa: boolean;
    BingeEatingDisorder: boolean;
    AvoidantRestrictiveFoodIntakeDisorder: boolean;
    OtherSpecifiedFeedingOrEatingDisorder: boolean;
    OtherSpecifiedFeedingOrEatingDisorderDescription: string;
    EatingDisorderComments: string;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    IsAIDiagnosedWithEatingDisorder: boolean;
}

export class EatingDisorderModel implements IEatingDisorderModel {
    Id: string;
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    DiagnosedWithEatingDisorder: string;
    AnorexiaNervoxa: boolean;
    BulimiaNervosa: boolean;
    BingeEatingDisorder: boolean;
    AvoidantRestrictiveFoodIntakeDisorder: boolean;
    OtherSpecifiedFeedingOrEatingDisorder: boolean;
    OtherSpecifiedFeedingOrEatingDisorderDescription: string;
    EatingDisorderComments: string;

    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    IsAIDiagnosedWithEatingDisorder: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.AnorexiaNervoxa = false;
        this.BulimiaNervosa = false;
        this.BingeEatingDisorder = false;
        this.AvoidantRestrictiveFoodIntakeDisorder = false;
        this.OtherSpecifiedFeedingOrEatingDisorder = false;
        this.OtherSpecifiedFeedingOrEatingDisorderDescription = '';

        this.IsAssessmentCompleted = false;
        this.AssessmentStatus = 0;
        this.IsAIDiagnosedWithEatingDisorder = false;
    }
}
